import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ 
  children, 
  className = '', 
  hover = false, 
  glass = false,
  gradient = false,
  noPadding = false,
  onClick = null,
  ...props 
}) => {
  // Base styling with improved shadows and borders
  const baseClasses = glass 
    ? 'bg-white/95 backdrop-blur-sm rounded-lg sm:rounded-xl shadow-sm border border-gray-200'
    : 'bg-white rounded-lg sm:rounded-xl shadow-sm border border-gray-200';
  
  const paddingClasses = noPadding ? '' : 'p-3 sm:p-4 md:p-6';
  
  const hoverClasses = hover 
    ? 'hover:shadow-md hover:border-gray-300 cursor-pointer group' 
    : '';
  
  const gradientClasses = gradient 
    ? 'bg-gradient-to-br from-white via-white to-red-50/30' 
    : '';
  
  return (
    <motion.div
      initial={{ opacity: 0.95 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.15 }}
      whileHover={hover ? { 
        y: -2,
        transition: { type: 'spring', stiffness: 300, damping: 25 }
      } : {}}
      className={`${baseClasses} ${paddingClasses} ${hoverClasses} ${gradientClasses} ${className} transition-all duration-200`}
      onClick={onClick}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default Card;

